"use strict";

exports.__esModule = true;
exports.SectionLabelWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _SectionLabelElement = require("./SectionLabelElement");
var _SectionLabelFields = require("./SectionLabelFields");
var _SectionLabelHeader = require("./SectionLabelHeader");
var _SectionLabelThumbnail = require("./SectionLabelThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SectionLabelWidget = exports.SectionLabelWidget = {
  name: "SectionLabel",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "SectionLabelWidget.label",
    defaultMessage: "Label"
  }),
  icon: "label",
  group: _widgetGroups.OTHER_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "SectionLabel",
      props: Object.assign({
        width: 256,
        height: 64,
        flex: 1,
        content: "New Label"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "content"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _SectionLabelHeader.SectionLabelHeader,
    Element: _SectionLabelElement.SectionLabelElement,
    Fields: _SectionLabelFields.SectionLabelFields,
    Thumbnail: _SectionLabelThumbnail.SectionLabelThumbnail
  }
};